import { WALLET_URL } from 'constants/config';
import type { PaymentMethod } from 'models/paymentMethod';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

const WalletService = {
  fetchPaymentMethods: (): Promise<PaymentMethod[]> => {
    const options = { method: 'GET' };
    const url = `${WALLET_URL}/payment_methods`;

    return fetchWithAuthentication(url, options);
  },

  removeCreditCard: (token: string) => {
    const options = { method: 'DELETE' };

    const url = `${WALLET_URL}/${token}`;

    return fetchWithAuthentication(url, options);
  },

  removeNewCreditCard: ({
    apiConfirmationUrl,
    uuidToken,
  }: {
    apiConfirmationUrl: string;
    uuidToken: string;
  }) => {
    const path = `${WALLET_URL}/remove_new_card`;
    const body = JSON.stringify({
      api_confirmation_url: apiConfirmationUrl,
      uuid_token: uuidToken,
    });
    const options = {
      method: 'POST',
      body,
    };

    return fetchWithAuthentication(path, options);
  },
};

export { WalletService };
